import 'react-phone-number-input/style.css';

import * as React from 'react';
import { useEffect, useState } from 'react';
import PhoneInput, { Country, getCountryCallingCode } from 'react-phone-number-input';

type Props = {
  /** Original <input> rendered by the form body. It becomes hidden and carries the E.164 value on submit. */
  source: HTMLInputElement;
  countries?: Country[];
  defaultCountry?: Country;
  international?: boolean;
};

const PhoneField: React.FC<Props> = ({ source, countries, defaultCountry, international = true }) => {
  const [value, setValue] = useState<string | undefined>(undefined);

  const singleCountry = countries?.length === 1 ? countries[0] : undefined;
  const country = singleCountry ?? defaultCountry;

  const handleChange = (next?: string) => {
    setValue(next);

    // When the prefix is locked, a bare prefix means "empty".
    const prefixOnly = !!singleCountry && next === `+${getCountryCallingCode(singleCountry)}`;
    source.value = next && !prefixOnly ? next : '';
  };

  useEffect(() => {
    const form = source.form;
    if (!form) return;

    const onReset = () => {
      setValue(undefined);
      source.value = '';
    };
    form.addEventListener('reset', onReset);

    return () => form.removeEventListener('reset', onReset);
  }, [source]);

  return (
    <PhoneInput
      value={value}
      onChange={handleChange}
      placeholder={source.placeholder || undefined}
      required={source.required}
      readOnly={source.readOnly}
      disabled={source.disabled}
      countries={countries?.length ? countries : undefined}
      defaultCountry={country}
      {...(singleCountry
        ? {
            country: singleCountry,
            international: true,
            withCountryCallingCode: true,
            countryCallingCodeEditable: false
          }
        : { international })}
    />
  );
};

export default PhoneField;
